import styled from 'styled-components';
import { flexMixin, textMixin } from '@styles/mixins';
import { Select } from 'antd';
import { colors } from '@styles';

export const FooterWrap = styled.div`
    display: flex;
    flex-direction: row;
`;

export const ActionWrap = styled.div`
    ${flexMixin('row', 'flex-start', 'center')};
    gap: 10px;
`;

export const StyledSelect = styled(Select)`
    box-sizing: border-box;
    ${flexMixin('row', 'center', 'center')}
    gap: 10px;
    width: 175px;
    height: 34px;
`;
export const TabsWrapper = styled.div``;

export const StyledActionButton = styled.div`
    ${flexMixin('row', 'center', 'center')}
    padding: 5px 10px;
    gap: 10px;
    width: 98px;
    height: 34px;
    background: #a7388e;
    border-radius: 5px;
    cursor: pointer;
    & span {
        width: 78px;
        height: 28px;
        font-size: 14px;
        ${textMixin({
            fontSize: '14px',
            fontWeight: 500,
        })};
        line-height: 28px;
        display: flex;
        align-items: center;
        color: #f7f7f7;
        flex: none;
        order: 0;
        flex-grow: 0;
    }
`;

export const StyledAddButton = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 3px 25px;
    gap: 10px;
    cursor: pointer;
    width: 170px;
    height: 34px;
    background: #ffffff;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    flex: none;
    order: 0;
    flex-grow: 0;
    color: #8f8f8f;
    & svg {
        width: 20px;
        height: 20px;
        color: #8f8f8f;
    }
`;

export const SearchWrap = styled.div`
    ${flexMixin('row', 'space-between', 'center')}
    width: 100%;
`;
export const SearchInput = styled.input`
    width: 1135px;
    padding-left: 20px;
    height: 33px;
    background: #ffffff;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    border: none;
`;
export const ButtonBlock = styled.div`
    ${flexMixin('row', 'space-between', 'center')}
    gap: 12px;
`;
export const StyledButton = styled.div`
    width: 33px;
    height: 33px;
    background: #cd6ee5;
    box-sizing: border-box;
    border: 0.5px solid #cd6ee5;
    box-shadow: -1px 1px 4px 1px rgba(0, 0, 0, 0.24);
    border-radius: 3px;
    padding: 5px;
    cursor: pointer;
`;

export const TableWrapper = styled.div`
    padding-bottom: 20px;
    margin-top: 0;

    .ant-table-wrapper {
        min-height: 100%;
    }

    .ant-table-thead {
        line-height: 50px;
        height: 45px !important;
        background: rgba(148, 129, 205, 0.25);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px 5px 0 0;
    }
    .ant-table-thead > tr > th::before {
        content: none !important;
    }
    .ant-table-cell {
        border-right: none !important;
        border-left: none !important;
        font-size: 14px !important;
    }

    .ant-table-row .ant-table-cell {
        height: 46px !important;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 28px;
        align-items: center;
        color: #333333;

        & svg {
            margin-top: 9px;
        }
    }
`;

export const HeaderTitle = styled.div`
    margin-top: 38px;
    margin-bottom: 26px;
    width: 110px;
    height: 28px;
    ${textMixin({
        fontSize: '27px',
        fontWeight: 600,
    })};
    line-height: 28px;
    align-items: center;
    color: ${colors.grey};
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    min-height: calc(100vh - 110px);
    top: 0;
    gap: 16px;

    .ant-table-row {
        height: 14px !important;
        padding: 2px !important;
    }

    .ant-table-cell {
        height: 14px !important;
        padding: 2px !important;
    }

    .ant-table-tbody > tr > td {
        background-color: ${colors.cleanWhite};
        border: 1px solid #efefef;
        color: ${colors.grey};
        ${textMixin({
            fontSize: '12px',
            fontWeight: 400,
        })};
        line-height: 12px;
        text-align: left;
        padding: 2px;
        height: 12px;
    }

    .ant-table-summary {
        background-color: #9481cd40;
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 17px;
        text-align: left;
    }

    .ant-table-thead > tr > th {
        background-color: #9481cd40;
        ${textMixin({
            fontSize: '12px',
            fontWeight: 600,
        })};
        line-height: 13px;
        text-align: left;
    }
`;

export const Header = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    top: 0;
    margin-bottom: 30px;
`;

export const Overlay = styled.div<{
    display: string;
}>`
    display: ${({ display }) => display};
    position: absolute;
    top: -1px;
    left: -1px;
    z-index: 1000;
    width: 100vw;
    height: 150vh;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(1px);
    transition: width 0.3s;
`;
